import { render, staticRenderFns } from "./difficulty.vue?vue&type=template&id=28cf8844&"
import script from "./difficulty.vue?vue&type=script&lang=js&"
export * from "./difficulty.vue?vue&type=script&lang=js&"
import style0 from "./difficulty.vue?vue&type=style&index=0&id=28cf8844&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports